export const zipCodes = [
  {
    country: 'US',
    regex: /(^[A-Za-z0-9]{5}$)|(^[A-Za-z0-9]{9}$)/,
  },
  {
    country: 'GB',
    regex:
      /(GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4})/,
  },

  {
    country: 'JE',
    regex: /(JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2})/,
  },
  {
    country: 'GG',
    regex: /(GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2})/,
  },
  {
    country: 'IM',
    regex: /(IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2})/,
  },
  {
    country: 'CA',
    regex: /([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d)/,
  },
  {
    country: 'DE',
    regex: /(\d{5})/,
  },
  {
    country: 'JP',
    regex: /(\d{3}-\d{4})/,
  },
  {
    country: 'FR',
    regex: /(\d{2}[ ]?\d{3})/,
  },
  {
    country: 'AU',
    regex: /(\d{4})/,
  },
  {
    country: 'IT',
    regex: /(\d{5})/,
  },
  {
    country: 'CH',
    regex: /(\d{4})/,
  },
  {
    country: 'AT',
    regex: /(\d{4})/,
  },
  {
    country: 'ES',
    regex: /(\d{5})/,
  },
  {
    country: 'NL',
    regex: /(\d{4}[ ]?[A-Z]{2})/,
  },
  {
    country: 'BE',
    regex: /(\d{4})/,
  },
  {
    country: 'DK',
    regex: /(\d{4})/,
  },
  {
    country: 'SE',
    regex: /(\d{3}[ ]?\d{2})/,
  },
  {
    country: 'NO',
    regex: /(\d{4})/,
  },
  {
    country: 'BR',
    regex: /(\d{5}[-]?\d{3})/,
  },
  {
    country: 'PT',
    regex: /(\d{4}([-]\d{3})?)/,
  },
  {
    country: 'FI',
    regex: /(\d{5})/,
  },
  {
    country: 'AX',
    regex: /(22\d{3})/,
  },
  {
    country: 'KR',
    regex: /(\d{3}[-]\d{3})/,
  },
  {
    country: 'CN',
    regex: /(\d{6})/,
  },
  {
    country: 'TW',
    regex: /(\d{3}(\d{2})?)/,
  },
  {
    country: 'SG',
    regex: /(\d{6})/,
  },
  {
    country: 'DZ',
    regex: /(\d{5})/,
  },
  {
    country: 'AD',
    regex: /(AD\d{3})/,
  },
  {
    country: 'AR',
    regex: /(([A-HJ-NP-Z])?\d{4}([A-Z]{3})?)/,
  },
  {
    country: 'AM',
    regex: /((37)?\d{4})/,
  },
  {
    country: 'AZ',
    regex: /(\d{4})/,
  },
  {
    country: 'BH',
    regex: /(((1[0-2]|[2-9])\d{2})?)/,
  },
  {
    country: 'BD',
    regex: /(\d{4})/,
  },
  {
    country: 'BB',
    regex: /((BB\d{5})?)/,
  },
  {
    country: 'BY',
    regex: /(\d{6})/,
  },
  {
    country: 'BM',
    regex: /([A-Z]{2}[ ]?[A-Z0-9]{2})/,
  },
  {
    country: 'BA',
    regex: /(\d{5})/,
  },
  {
    country: 'IO',
    regex: /(BBND 1ZZ)/,
  },
  {
    country: 'BN',
    regex: /([A-Z]{2}[ ]?\d{4})/,
  },
  {
    country: 'BG',
    regex: /(\d{4})/,
  },
  {
    country: 'KH',
    regex: /(\d{5})/,
  },
  {
    country: 'CV',
    regex: /(\d{4})/,
  },
  {
    country: 'CL',
    regex: /(\d{7})/,
  },
  {
    country: 'CR',
    regex: /(\d{4,5}|\d{3}-\d{4})/,
  },
  {
    country: 'HR',
    regex: /(\d{5})/,
  },
  {
    country: 'CY',
    regex: /(\d{4})/,
  },
  {
    country: 'CZ',
    regex: /(\d{3}[ ]?\d{2})/,
  },
  {
    country: 'DO',
    regex: /(\d{5})/,
  },
  {
    country: 'EC',
    regex: /(([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?)/,
  },
  {
    country: 'EG',
    regex: /(\d{5})/,
  },
  {
    country: 'EE',
    regex: /(\d{5})/,
  },
  {
    country: 'FO',
    regex: /(\d{3})/,
  },
  {
    country: 'GE',
    regex: /(\d{4})/,
  },
  {
    country: 'GR',
    regex: /(\d{3}[ ]?\d{2})/,
  },
  {
    country: 'GL',
    regex: /(39\d{2})/,
  },
  {
    country: 'GT',
    regex: /(\d{5})/,
  },
  {
    country: 'HT',
    regex: /(\d{4})/,
  },
  {
    country: 'HN',
    regex: /((?:\d{5})?)/,
  },
  {
    country: 'HU',
    regex: /(\d{4})/,
  },
  {
    country: 'IS',
    regex: /(\d{3})/,
  },
  {
    country: 'IN',
    regex: /(\d{6})/,
  },
  {
    country: 'ID',
    regex: /(\d{5})/,
  },
  {
    country: 'IL',
    regex: /(\d{5})/,
  },
  {
    country: 'JO',
    regex: /(\d{5})/,
  },
  {
    country: 'KZ',
    regex: /(\d{6})/,
  },
  {
    country: 'KE',
    regex: /(\d{5})/,
  },
  {
    country: 'KW',
    regex: /(\d{5})/,
  },
  {
    country: 'LA',
    regex: /(\d{5})/,
  },
  {
    country: 'LV',
    regex: /(\d{4})/,
  },
  {
    country: 'LB',
    regex: /((\d{4}([ ]?\d{4})?)?)/,
  },
  {
    country: 'LI',
    regex: /((948[5-9])|(949[0-7]))/,
  },
  {
    country: 'LT',
    regex: /(\d{5})/,
  },
  {
    country: 'LU',
    regex: /(\d{4})/,
  },
  {
    country: 'MK',
    regex: /(\d{4})/,
  },
  {
    country: 'MY',
    regex: /(\d{5})/,
  },
  {
    country: 'MV',
    regex: /(\d{5})/,
  },
  {
    country: 'MT',
    regex: /([A-Z]{3}[ ]?\d{2,4})/,
  },
  {
    country: 'MU',
    regex: /((\d{3}[A-Z]{2}\d{3})?)/,
  },
  {
    country: 'MX',
    regex: /(\d{5})/,
  },
  {
    country: 'MD',
    regex: /(\d{4})/,
  },
  {
    country: 'MC',
    regex: /(980\d{2})/,
  },
  {
    country: 'MA',
    regex: /(\d{5})/,
  },
  {
    country: 'NP',
    regex: /(\d{5})/,
  },
  {
    country: 'NZ',
    regex: /(\d{4})/,
  },
  {
    country: 'NI',
    regex: /(((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?)/,
  },
  {
    country: 'NG',
    regex: /((\d{6})?)/,
  },
  {
    country: 'OM',
    regex: /((PC )?\d{3})/,
  },
  {
    country: 'PK',
    regex: /(\d{5})/,
  },
  {
    country: 'PY',
    regex: /(\d{4})/,
  },
  {
    country: 'PH',
    regex: /(\d{4})/,
  },
  {
    country: 'PL',
    regex: /(\d{2}-\d{3})/,
  },
  {
    country: 'PR',
    regex: /(00[679]\d{2}([ -]\d{4})?)/,
  },
  {
    country: 'RO',
    regex: /(\d{6})/,
  },
  {
    country: 'RU',
    regex: /(\d{6})/,
  },
  {
    country: 'SM',
    regex: /(4789\d)/,
  },
  {
    country: 'SA',
    regex: /(\d{5})/,
  },
  {
    country: 'SN',
    regex: /(\d{5})/,
  },
  {
    country: 'SK',
    regex: /(\d{3}[ ]?\d{2})/,
  },
  {
    country: 'SI',
    regex: /(\d{4})/,
  },
  {
    country: 'ZA',
    regex: /(\d{4})/,
  },
  {
    country: 'LK',
    regex: /(\d{5})/,
  },
  {
    country: 'TJ',
    regex: /(\d{6})/,
  },
  {
    country: 'TH',
    regex: /(\d{5})/,
  },
  {
    country: 'TN',
    regex: /(\d{4})/,
  },
  {
    country: 'TR',
    regex: /(\d{5})/,
  },
  {
    country: 'TM',
    regex: /(\d{6})/,
  },
  {
    country: 'UA',
    regex: /(\d{5})/,
  },
  {
    country: 'UY',
    regex: /(\d{5})/,
  },
  {
    country: 'UZ',
    regex: /(\d{6})/,
  },
  {
    country: 'VA',
    regex: /(00120)/,
  },
  {
    country: 'VE',
    regex: /(\d{4})/,
  },
  {
    country: 'ZM',
    regex: /(\d{5})/,
  },
  {
    country: 'AS',
    regex: /(96799)/,
  },
  {
    country: 'CC',
    regex: /(6799)/,
  },
  {
    country: 'CK',
    regex: /(\d{4})/,
  },
  {
    country: 'RS',
    regex: /(\d{6})/,
  },
  {
    country: 'ME',
    regex: /(8\d{4})/,
  },
  {
    country: 'CS',
    regex: /(\d{5})/,
  },
  {
    country: 'YU',
    regex: /(\d{5})/,
  },
  {
    country: 'CX',
    regex: /(6798)/,
  },
  {
    country: 'ET',
    regex: /(\d{4})/,
  },
  {
    country: 'FK',
    regex: /(FIQQ 1ZZ)/,
  },
  {
    country: 'NF',
    regex: /(2899)/,
  },
  {
    country: 'FM',
    regex: /((9694[1-4])([ -]\d{4})?)/,
  },
  {
    country: 'GF',
    regex: /(9[78]3\d{2})/,
  },
  {
    country: 'GN',
    regex: /(\d{3})/,
  },
  {
    country: 'GP',
    regex: /(9[78][01]\d{2})/,
  },
  {
    country: 'GS',
    regex: /(SIQQ 1ZZ)/,
  },
  {
    country: 'GU',
    regex: /(969[123]\d([ -]\d{4})?)/,
  },
  {
    country: 'GW',
    regex: /(\d{4})/,
  },
  {
    country: 'HM',
    regex: /(\d{4})/,
  },
  {
    country: 'IQ',
    regex: /(\d{5})/,
  },
  {
    country: 'KG',
    regex: /(\d{6})/,
  },
  {
    country: 'LR',
    regex: /(\d{4})/,
  },
  {
    country: 'LS',
    regex: /(\d{3})/,
  },
  {
    country: 'MG',
    regex: /(\d{3})/,
  },
  {
    country: 'MH',
    regex: /(969[67]\d([ -]\d{4})?)/,
  },
  {
    country: 'MN',
    regex: /(\d{6})/,
  },
  {
    country: 'MP',
    regex: /(9695[012]([ -]\d{4})?)/,
  },
  {
    country: 'MQ',
    regex: /(9[78]2\d{2})/,
  },
  {
    country: 'NC',
    regex: /(988\d{2})/,
  },
  {
    country: 'NE',
    regex: /(\d{4})/,
  },
  {
    country: 'VI',
    regex: /(008(([0-4]\d)|(5[01]))([ -]\d{4})?)/,
  },
  {
    country: 'PF',
    regex: /(987\d{2})/,
  },
  {
    country: 'PG',
    regex: /(\d{3})/,
  },
  {
    country: 'PM',
    regex: /(9[78]5\d{2})/,
  },
  {
    country: 'PN',
    regex: /(PCRN 1ZZ)/,
  },
  {
    country: 'PW',
    regex: /(96940)/,
  },
  {
    country: 'RE',
    regex: /(9[78]4\d{2})/,
  },
  {
    country: 'SH',
    regex: /((ASCN|STHL) 1ZZ)/,
  },
  {
    country: 'SJ',
    regex: /(\d{4})/,
  },
  {
    country: 'SO',
    regex: /(\d{5})/,
  },
  {
    country: 'SZ',
    regex: /([HLMS]\d{3})/,
  },
  {
    country: 'TC',
    regex: /(TKCA 1ZZ)/,
  },
  {
    country: 'WF',
    regex: /(986\d{2})/,
  },
  {
    country: 'XK',
    regex: /(\d{5})/,
  },
  {
    country: 'YT',
    regex: /(976\d{2})/,
  },
];



// WEBPACK FOOTER //
// ./src/constants.js